if (!customElements.get('faq-clean-accordion')) {
  customElements.define(
    'faq-clean-accordion',
    class FaqCleanAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        if (!this.items.length) return;

        this.singleOpen = this.dataset.singleOpen === 'true';
        this.onToggle = this.onToggle.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.items.forEach((item) => {
          item.addEventListener('toggle', this.onToggle);
        });

        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (!this.items || !this.items.length) return;

        this.items.forEach((item) => {
          item.removeEventListener('toggle', this.onToggle);
        });

        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onToggle(event) {
        const openedItem = event.target;
        if (!openedItem.open || !this.singleOpen) return;

        this.items.forEach((item) => {
          if (item !== openedItem) item.open = false;
        });
      }

      onBlockSelect(event) {
        const selectedItem = event.target.closest('[data-faq-item]');
        if (!selectedItem || !this.contains(selectedItem)) return;

        if (!selectedItem.open) selectedItem.open = true;

        if (this.singleOpen) {
          this.items.forEach((item) => {
            if (item !== selectedItem) item.open = false;
          });
        }

        selectedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  );
}
